import { BooleanFeature } from "./BooleanFeature";
import { FeatureCell } from "./FeatureCell";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface FeatureRowProps {
  basic?: boolean | string;
  business?: boolean | string;
  enterprise?: boolean | string;
  professional?: boolean | string;
  title: string;
}

export const FeatureRow = ({
  title,
  basic,
  professional,
  business,
  enterprise,
}: FeatureRowProps) => {
  const { plans } = usePlans();

  const tierValues = { basic, professional, business, enterprise };
  const availableTiers = Object.entries(tierValues).filter(([tier]) =>
    plans.some(plan => plan.tier === tier),
  );

  return (
    <>
      <FeatureCell>
        <StringFeature className="pr-5" value={title} hideCheckIcon />
      </FeatureCell>
      {availableTiers.map(([tier, value]) => (
        <FeatureCell key={tier}>
          {typeof value === "string" ? (
            <StringFeature value={value} />
          ) : (
            <BooleanFeature value={!!value} />
          )}
        </FeatureCell>
      ))}
    </>
  );
};
